/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if (typeof ShopifyAPI === "undefined") {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if (typeof attribute !== "string") {
    attribute += "";
    if (attribute === "undefined") {
      attribute = "";
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // console.log('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
  console.log("Updating cart (updateCartNote)...");
  var params = {
    type: "POST",
    url: "/cart/update.js",
    data: "note=" + attributeToString(note),
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  if (!!data.message) {
    console.log(
      "Error: " + data.message + "(" + data.status + "): " + data.description
    );
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: jQuery(form).serialize(),
    dataType: "json",
    success: function (line_item) {
      if (typeof callback === "function") {
        callback(line_item, form);
        console.log("Item added.");
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (typeof errorCallback === "function") {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    },
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON("/cart.js", function (cart, textStatus) {
    if (typeof callback === "function") {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var params = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {
  "use strict";

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer,
    $addToCart,
    $cartCountSelector,
    $cartCostSelector,
    $cartContainer,
    $drawerContainer,
    $upsellButton,
    $addToCartReturnButton;
  // Private functions
  var updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    cartUpdateCallback,
    buildCart,
    cartCallback,
    adjustCart,
    adjustCartCallback,
    addToCartReturn,
    createQtySelectors,
    qtySelectors,
    validateQty,
    closeCart,
    validateFreeShipping,
    upsellButton,
    renderUpsellButton;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: "#CartContainer",
      addToCartSelector: ".enj-add-to-cart-btn",
      addToCartReturnSelector: ".enj-add-to-cart-return",
      upsellButtonSelector: "#UpsellButton",
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: "$",
      disableAjaxCart: false,
      enableQtySelectors: true,
      enableUpsell: true,
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);
    $upsellButton = $(settings.upsellButtonSelector);
    $addToCartReturnButton = $(settings.addToCartReturnSelector);

    // General Selectors
    $body = $("body");

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableUpsell) {
      // upsellButton();
      renderUpsellButton();
    }

    addToCartReturn();

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
    closeCart();
  };

  window.addEventListener(
    "DOMContentLoaded",
    (event) => {
      ShopifyAPI.getCart(cartUpdateCallback);
      addToCartReturn();
    },
    { passive: true }
  );

  loadCart = function () {
    $body.addClass("drawer--is-loading");
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass("hidden-count");

      if (cart.item_count === 0) {
        $cartCountSelector.addClass("hidden-count");
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(
        Shopify.formatMoney(cart.total_price, settings.moneyFormat)
      );
    }
  };

  formOverride = function () {
    $formContainer.on("submit", function (evt) {
      evt.preventDefault();
      var $addToCart_btn = $(this).find(settings.addToCartSelector);
      // Add class to be styled if desired
      $addToCart_btn.removeClass("is-added").addClass("is-adding");
      $addToCart_btn
        .find("i")
        .replaceWith(
          '<i class="enj-loader-add-to-cart"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></i>'
        );

      // Remove any previous quantity errors
      $(".qty-error").remove();

      var variantId = evt.target.getAttribute("data-variant");

      ShopifyAPI.addItemFromForm(
        evt.target,
        itemAddedCallback,
        itemErrorCallback
      );
    });
  };

  renderUpsellButton = function () {
    let remainingRelevantUpsellItems = [];
    let upsellItems = null;
    let displayedUpsellItem = null;

    // Matching logic

    /*
     * We have the following variant IDs
     * 20cm Pan - 35049784967324
     * 24cm Pan - 35049765601436
     * 28cm Pan - 31281645846659
     * 28cm Wok - 35851223433372
     * 20 + 24 Pan Set - 35059608715420
     * 24 + 28 Pan Set - 35060082933916
     * 20 + 24 + 28 Pan Set - 35060073201820
     * 20cm Pan Lid -
     * 24cm Pan Lid -
     * 28cm Pan Lid -
     **/
    const upsellProductLogic = [
      // {
      //   upsellItemVariantId: "44554838573322", // Dosenset
      //   upsellForProduct: ["43826228822282"], // variant IDs
      //   upsellItemHandle: "eisbehalter-2er-set",
      //   upsellItemCustomTitle: "+ Eisdosen 2er-Set",
      //   upsellType: "upsell",
      //   upsellPriority: 10
      // },
      {
        upsellItemVariantId: "44113491493130", // Extra Akku
        upsellForProduct: ["44109370982666"], // variant IDs
        upsellItemHandle: "extra-akku-fur-akkustaubsauger-420",
        upsellItemCustomTitle: "+ zusätzlicher Akku",
        upsellType: "upsell",
        upsellPriority: 10,
      },
      {
        upsellItemVariantId: "41160507654300", // Pfannendeckel Set 28cm
        upsellForProduct: ["31281645846659"], // variant IDs
        upsellItemHandle: "profi-edelstahl-bratpfanne",
        upsellItemCustomTitle: "Set mit Pfannendeckel",
        upsellType: "upgrade",
        upsellPriority: 10,
      },
      {
        upsellItemVariantId: "41160503099548", // Pfannendeckel Set 24cm
        upsellForProduct: ["35049765601436"], // variant IDs
        upsellItemHandle: "profi-edelstahl-bratpfanne-24cm",
        upsellItemCustomTitle: "Set mit Pfannendeckel",
        upsellType: "upgrade",
        upsellPriority: 10,
      },
      {
        upsellItemVariantId: "41160466759836", // Pfannendeckel Set 20cm
        upsellForProduct: ["35049784967324"], // variant IDs
        upsellItemHandle: "profi-edelstahl-bratpfanne-20cm",
        upsellItemCustomTitle: "Set mit Pfannendeckel",
        upsellType: "upgrade",
        upsellPriority: 10,
      },
      {
        upsellItemVariantId: "39251313623196", // Filz Set
        upsellForProduct: [
          "35049784967324",
          "35049765601436",
          "31281645846659",
          "35851223433372",
          "35059608715420",
          "35060082933916",
          "35060073201820",
        ], // variant IDs
        upsellItemHandle: "pfannenschoner-filz-6er-set",
        upsellType: "upsell",
        upsellPriority: 9,
      },
      {
        upsellItemVariantId: "37594986414236",
        upsellForProduct: [
          "30197092778115",
          "39371130372252",
          "39371341463708",
        ], // variant IDs
        upsellItemHandle: "schleifstein-1000-6000",
        upsellType: "upsell",
        upsellPriority: 6,
      },
      {
        upsellItemVariantId: "40891199586460", // Vaku Rollen 3er Set
        upsellForProduct: ["39388892364956"], // variant IDs
        upsellItemHandle: "vakuumbeutel-rollen-3er-set",
        upsellType: "upsell",
        upsellPriority: 9,
      },
      {
        upsellItemVariantId: "35060082933916",
        upsellForProduct: ["35049765601436", "31281645846659"], // variant IDs
        upsellItemHandle: "bratpfannen-set-24cm-28cm",
        upsellItemCustomTitle: "Set 24cm & 28cm",
        upsellType: "upgrade",
        upsellPriority: 9,
      },
      {
        upsellItemVariantId: "35060073201820",
        upsellForProduct: ["35049784967324", "35060082933916"], // variant IDs
        upsellItemHandle: "bratpfannen-set-20cm-24cm-28cm",
        upsellItemCustomTitle: "Set 20cm & 24cm & 28cm",
        upsellType: "upgrade",
        upsellPriority: 8,
      },
      {
        upsellItemVariantId: "36995423994012",
        upsellForProduct: ["30197092778115"], // variant IDs
        upsellItemHandle: "damastmesser-schneidebrett-set",
        upsellItemCustomTitle: "Set mit Bambusbrett",
        upsellType: "upgrade",
        upsellPriority: 9,
      },
    ];

    const renderUpsellItems = () => {
      const upsellDataComplete =
        upsellItems &&
        displayedUpsellItem &&
        displayedUpsellItem.upsellItemHandle &&
        displayedUpsellItem.upsellType &&
        upsellItems[0].variants[0].id &&
        upsellItems[0].images[0]
          ? true
          : false;

      if (upsellDataComplete) {
        let $UpsellDiv = $("body").find("#upsellButtonDiv");
        $UpsellDiv.removeClass("hidden");

        let upsellDivs = [];

        $.each(upsellItems, (index, upsellItem) => {
          const matchingUpsellItem = remainingRelevantUpsellItems.filter(
            (x) => {
              const variantIds = upsellItem.variants.map((x) => x.id);
              if (variantIds.includes(parseInt(x.upsellItemVariantId))) {
                return true;
              }
            }
          )[0];

          const upsellVariant = upsellItem.variants.filter((x) => {
            if (parseInt(matchingUpsellItem.upsellItemVariantId) === x.id) {
              return true;
            }
          })[0];

          upsellDivs.push(`<div style="background-color: #eee; height: 60px; display: flex; flex-direction: row;">
            <a href="/products/${
              matchingUpsellItem.upsellItemHandle
            }" style="width: 70px; height: 40px; margin: 10px; margin-right: 8px">
              <img src="${
                upsellItem.images[0]
              }" style="width: 40px; height: 40px; margin-top: 0">
            </a>
            <a href="/products/${
              matchingUpsellItem.upsellItemHandle
            }" style="width: 100%; height: 100%; margin: 10px 0;">
              <div class="upsell-button-product-title">${
                matchingUpsellItem.upsellItemCustomTitle
                  ? matchingUpsellItem.upsellItemCustomTitle
                  : upsellItem.title
              }</div>
              <div style="font-weight: 400; font-size: 12px; opacity: .7">€${
                upsellVariant.price / 100
              }</div>
            </a>
            <div style="${
              matchingUpsellItem.upsellType === "upsell"
                ? `width: 75px;`
                : `width: 100px;`
            } float: right; margin: auto; margin-right: 10px;">
              <a class="upsell-button" id="UpsellButton-${index}" data-upsell-type="${
            matchingUpsellItem.upsellType
          }" data-upsell-title=${
            matchingUpsellItem.upsellItemHandle
          } data-variant="${
            matchingUpsellItem.upsellItemVariantId
          }" href="#" style="${
            matchingUpsellItem.upsellType === "upsell"
              ? `width: 75px;`
              : `width: 100px;`
          }">
                ${
                  matchingUpsellItem.upsellType === "upsell"
                    ? `<i class="fa fa-plus" aria-hidden="true"></i>
                <span style="float: right; margin-top: 1px">Dazu</span>`
                    : `<i class="fa fa-arrow-up" aria-hidden="true"></i><span style="float: right; margin-top: 1px">Upgrade</span>`
                }
              </a>
            </div>
          </div>`);
        });

        const upsellButtonTemplate = `
            <div class="slick-upsell" style="margin: 30px; margin-left: 35px; margin-right: 35px;">
              ${upsellDivs.join("")}
            </div>
            `;
        $UpsellDiv.append(upsellButtonTemplate);
        $(".slick-upsell").slick({
          prevArrow: `<button type="button" class="upsell-switch slick-prev" style="left: -25px !important;"></button>`,
          nextArrow: `<button type="button" class="upsell-switch slick-next" style="right: -25px !important;">Next</button>`,
        });

        // Attach event listener
        upsellButton(displayedUpsellItem);
      } else {
        // $UpsellDiv.removeClass("hidden")
      }
    };

    const setUpsellItems = async (upsellData) => {
      let upsellItemsData = [];

      const promises = upsellData.map((u) => {
        return new Promise((resolve, reject) => {
          Shopify.getProduct(u.upsellItemHandle, (response) => {
            upsellItemsData.push({
              ...response,
              upsellPriority: u.upsellPriority,
            });
            resolve();
          });
        });
      });
      await Promise.all(promises);

      // loop and get product data
      upsellItems = upsellItemsData.sort(
        (a, b) => b.upsellPriority - a.upsellPriority
      );

      renderUpsellItems();
    };

    // Get cart items
    const processCartResponse = (cartResponse) => {
      if (cartResponse.items && cartResponse.items.length > 0) {
        // Format cart items
        const cartItems = cartResponse.items.map((x) => {
          return {
            title: x.product_title,
            price: x.price,
            variantId: x.id,
          };
        });

        // Get all upsell items that could be relevant
        let relevantUpsellItems = [];
        cartItems.forEach((i) => {
          upsellProductLogic.forEach((l) => {
            if (l.upsellForProduct.includes(i.variantId.toString())) {
              relevantUpsellItems.push(l);
            }
          });
        });

        // Make sure that upsellItems are not in cart already. If they are, check if additional upsells are possible
        const cartItemIds = cartItems.map((c) => c.variantId);
        remainingRelevantUpsellItems = relevantUpsellItems.filter((i) => {
          if (cartItemIds.includes(parseInt(i.upsellItemVariantId)) === false) {
            return true;
          }
        });

        if (remainingRelevantUpsellItems.length >= 1 && cartItems.length < 3) {
          console.log("Displaying upsell button...");
          displayedUpsellItem = remainingRelevantUpsellItems[0];
          setUpsellItems(remainingRelevantUpsellItems);
        } else {
          let $UpsellDiv = $("body").find("#upsellButtonDiv");
          $UpsellDiv.html();
          console.log("Hiding upsell button...");
          $UpsellDiv.addClass("hidden");
        }
      }
    };

    Shopify.getCart(processCartResponse);
  };

  upsellButton = function (displayedUpsellItem) {
    // Get possible upsell items
    $('[id*="UpsellButton"]').on("click", function (evt) {
      console.log("Adding upsell item...");
      evt.preventDefault();

      const upsellItemTitle =
        evt.currentTarget.getAttribute("data-upsell-title");

      dataLayer.push({
        event: "upsell-button-click",
        upsellItem: upsellItemTitle,
      });

      const variantId = evt.currentTarget.getAttribute("data-variant");
      const upsellType = evt.currentTarget.getAttribute("data-upsell-type");

      if (upsellType === "upsell") {
        Shopify.addItem(variantId, 1, itemAddedCallback, itemErrorCallback);
      } else if (upsellType === "upgrade") {
        // Replace upgraded product via updating the cart
        Shopify.getCart((response) => {
          let cartUpdates = [];
          response.items.forEach((item, index) => {
            if (
              displayedUpsellItem.upsellForProduct.includes(
                item.variant_id.toString()
              )
            ) {
              cartUpdates.push({
                id: item.variant_id,
                quantity: item.quantity - 1,
              });
            }
          });

          cartUpdates.push({
            id: variantId,
            quantity: 1,
          });

          let cartUpdatesObject = {};
          cartUpdates.forEach((x) => {
            cartUpdatesObject[x.id] = x.quantity;
          });

          $.post("/cart/update.js", { updates: cartUpdatesObject });
          Shopify.getCart(itemAddedCallback);
        });
      }
    });
  };

  addToCartReturn = function () {
    // Get possible upsell items
    $("#AddToCartReturn").on("click", function (evt) {
      console.log("Adding return item...");
      evt.preventDefault();

      const variantId = evt.currentTarget.getAttribute("data-variant");
      console.log("variantId: ", variantId);

      // dataLayer.push({
      //   event: "upsell-button-click",
      //   upsellItem: upsellItemTitle,
      // });

      // const variantId = evt.currentTarget.getAttribute("data-variant");
      // const upsellType = evt.currentTarget.getAttribute("data-upsell-type");

      Shopify.addItem(variantId, 1, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product, form) {
    // console.log("product: ", product)
    // console.log("form: ", form)
    var $addToCart_btn = $(form).find(settings.addToCartSelector);
    $addToCart_btn.removeClass("is-adding").addClass("is-added");
    $addToCart_btn
      .find(".enj-loader-add-to-cart")
      .html('<i class="fa fa-check"></i>');

    $(".product-popup").find(".product-name").html(product.product_title);
    $(".product-popup").find(".product-image img").attr("src", product.image);

    const windowWidth = jQuery(window).width();

    ShopifyAPI.getCart(cartUpdateCallback);

    if (windowWidth > 767) {
      // showPopup('.product-popup');
      $(".icon-cart").toggleClass("active");
      if (!$("body").hasClass("pushmenu-push-toright-cart")) {
        $("body").toggleClass("pushmenu-push-toright-cart");
        $(".pushmenu-left").toggleClass("pushmenu-open");
      }
      $(".container").toggleClass("canvas-container");
    } else {
      $(".icon-cart").toggleClass("active");
      if (!$("body").hasClass("pushmenu-push-toright-cart")) {
        $("body").toggleClass("pushmenu-push-toright-cart");
        $(".pushmenu-left").toggleClass("pushmenu-open");
      }
      // $('body').toggleClass('pushmenu-push-toright-cart');
      // $('.pushmenu-left').toggleClass('pushmenu-open');
      // $(".container").toggleClass("canvas-container");
    }
    // renderUpsellButton()
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    console.log("Error: ", XMLHttpRequest.responseText);
    console.log("textStatus: ", textStatus);
    var data = eval("(" + XMLHttpRequest.responseText + ")");
    $addToCart.removeClass("is-adding is-added");
    $addToCart.find(".enj-loader-add-to-cart").remove();

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after(
          '<div class="errors qty-error">' + data.description + "</div>"
        );
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price

    $(".enj-cartcount").html(cart.item_count);
    $(".enj-cartcount").css({ opacity: 1 });

    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    console.log("Building cart...");

    // Show empty cart
    if (cart.item_count === 0) {
      var source = $("#CartEmpty").html(),
        template = Handlebars.compile(source);

      // Append new quantity selector then remove original
      $cartContainer.append(template());
      // .append('<p>' + "Ihr Warenkorb ist im Moment leer." + '</p>');

      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      if (cartItem.image != null) {
        var prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, "_small$1")
          .replace("http:", "");
      } else {
        var prodImg =
          "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        // name: cartItem.product_title,
        name: cartItem.product_title,
        variant: cartItem.variant_id,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      count: cart.item_count,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
    };

    $cartContainer.append(template(data));

    validateFreeShipping(cart.total_price);

    renderUpsellButton();

    cartCallback(cart);
  };

  cartCallback = function (cart) {
    $body.removeClass("drawer--is-loading");
    $body.trigger("ajaxCart.afterCartLoad", cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on("click", ".ajaxcart__qty-adjust", function () {
      var $el = $(this),
        line = $el.data("line"),
        $qtySelector = $el.siblings(".ajaxcart__qty-num"),
        qty = parseInt($qtySelector.val().replace(/\D/g, ""));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      console.log("Qty: " + qty);

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Remove item (set quantity to 0)
    $body.on("click", "#product-remove", function () {
      var $el = $(this),
        line = $el.attr("line"),
        variant = $el.attr("variant");

      var qty = 0;

      ShopifyAPI.changeItem(line, qty, adjustCartCallback);
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on("submit", "form.ajaxcart", function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on("focus", ".ajaxcart__qty-adjust", function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass(
        "is-loading"
      );

      if (qty === 0) {
        $row.parent().addClass("is-removed");
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on("change", 'textarea[name="note"]', function () {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function (cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function () {
      ShopifyAPI.getCart(buildCart);
    }, 350);
  };

  createQtySelectors = function () {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function () {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#AjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            variant: $el.attr("variant"),
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function () {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr("name"),
          inputId = $el.attr("id"),
          variant = $el.attr("variant");
        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            id: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId,
            variant: variant,
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $(".js-qty__adjust").on("click", function () {
        var $el = $(this),
          id = $el.data("id"),
          $qtySelector = $el.siblings(".js-qty__num"),
          qty = parseInt($qtySelector.val().replace(/\D/g, ""));

        var variant =
          $el.next().attr("variant") && $el.next().attr("variant").length > 0
            ? $el.next().attr("variant")
            : $el.prev().attr("variant");

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass("js-qty__adjust--plus")) {
          qty += 1;
          updatePricingQty(qty);
          var changes = {
            updates: {
              [variant]: qty,
            },
          };
          $.post("/cart/update.js", changes);

          setTimeout(() => {
            ShopifyAPI.getCart((cart) => {
              // Adjust total price
              var price = "€" + cart.total_price / 100.0;
              var cleanPrice = price.replace(".", ",");
              const $priceElement = $(".price-total");
              $priceElement.text(cleanPrice);
              $priceElement
                .addClass("price-total-animate")
                .delay(1000)
                .queue(() => {
                  // Wait for 1 second.
                  $priceElement.removeClass("price-total-animate").dequeue();
                });

              // Check if it changes free shipping
              validateFreeShipping(cart.total_price);
            });
          }, 200);
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
          updatePricingQty(qty);
          var changes = {
            updates: {
              [variant]: qty,
            },
          };
          $.post("/cart/update.js", changes);

          setTimeout(() => {
            ShopifyAPI.getCart((cart) => {
              var price = "€" + cart.total_price / 100;
              var cleanPrice = price.replace(".", ",");
              const $priceElement = $(".price-total");
              $priceElement.text(cleanPrice);
              $priceElement
                .addClass("price-total-animate")
                .delay(1000)
                .queue(() => {
                  // Wait for 1 second.
                  $priceElement.removeClass("price-total-animate").dequeue();
                });
            });

            validateFreeShipping(cart.total_price);
          }, 100);
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateFreeShipping = (totalCart) => {
    const $freeShipping = $(".free-shipping-reached");
    const $noFreeShippingNot = $(".free-shipping-not-reached");

    if (totalCart >= 4400) {
      $freeShipping.removeClass("hidden");
      $noFreeShippingNot.addClass("hidden");
    } else {
      $freeShipping.addClass("hidden");
      $noFreeShippingNot.removeClass("hidden");
    }
  };

  validateQty = function (qty) {
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  closeCart = function () {
    $body.on("click", "#cartMenuClose", function () {
      var $el = $(".pushmenu-left");
      $el.removeClass("pushmenu-open");
      $("body").removeClass("pushmenu-push-toleft");
      $("body").removeClass("pushmenu-push-toright-cart");
    });

    // Search button in empty cart - closes cart and opens mobile menu with search
    $body.on("click", ".cart-search-btn", function (e) {
      e.preventDefault();
      // Close cart
      var $el = $(".pushmenu-left");
      $el.removeClass("pushmenu-open");
      $("body").removeClass("pushmenu-push-toleft");
      $("body").removeClass("pushmenu-push-toright-cart");
      // Open mobile menu
      setTimeout(function () {
        $(".menu-home5").addClass("pushmenu-open");
        $("body").addClass("pushmenu-push-toleft");
        // Focus search input after menu opens
        setTimeout(function () {
          $("#mobile-search-form-input").focus();
        }, 300);
      }, 100);
    });
  };

  module = {
    init: init,
    load: loadCart,
  };

  return module;
})(ajaxCart || {}, jQuery);
